
import ReceiptSquare from "../../../assets/filled/ReceiptSquare.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ReceiptSquareIcon({ className, dataTestid = "ReceiptSquareIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ReceiptSquare data-testid={dataTestid} className={classes} {...rest} />
  );
}
